module.exports = __webpack_public_path__ + "static/media/S1N10-3.6cf276c8.svg";